export type SupportedLanguage = {
  lang: string;
  name: string;
  /** URL slug for /languages/:slug */
  slug: string;
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { lang: 'en', name: 'English', slug: 'english' },
  { lang: 'es', name: 'Spanish', slug: 'spanish' },
  { lang: 'fr', name: 'French', slug: 'french' },
  { lang: 'de', name: 'German', slug: 'german' },
  { lang: 'it', name: 'Italian', slug: 'italian' },
  { lang: 'pt', name: 'Portuguese', slug: 'portuguese' },
  { lang: 'nl', name: 'Dutch', slug: 'dutch' },
  { lang: 'pl', name: 'Polish', slug: 'polish' },
  { lang: 'tr', name: 'Turkish', slug: 'turkish' },
  { lang: 'ru', name: 'Russian', slug: 'russian' },
  { lang: 'uk', name: 'Ukrainian', slug: 'ukrainian' },
  { lang: 'sv', name: 'Swedish', slug: 'swedish' },
  { lang: 'no', name: 'Norwegian', slug: 'norwegian' },
  { lang: 'da', name: 'Danish', slug: 'danish' },
];

export const LANGUAGE_FLAGS: Record<string, string> = {
  en: '🇺🇸',
  es: '🇪🇸',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹',
  pt: '🇵🇹',
  nl: '🇳🇱',
  pl: '🇵🇱',
  tr: '🇹🇷',
  ru: '🇷🇺',
  uk: '🇺🇦',
  sv: '🇸🇪',
  no: '🇳🇴',
  da: '🇩🇰',
};

export const SUPPORTED_LANGUAGE_COUNT = SUPPORTED_LANGUAGES.length;

export const SUPPORTED_LANGUAGE_NAMES = SUPPORTED_LANGUAGES.map((l) => l.name).join(
  ', '
);

export function getLanguageBySlug(
  slug: string | undefined
): SupportedLanguage | undefined {
  if (!slug) return undefined;
  const normalized = slug.trim().toLowerCase();
  return SUPPORTED_LANGUAGES.find((l) => l.slug === normalized);
}

export function languageLandingPath(language: SupportedLanguage): string {
  return `/languages/${language.slug}`;
}
